export default "__VITE_ASSET__CkABC8$Z__"